import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { formatDate, formatToZMW, sumOfArray } from "../../../helpers";
import { FaSpinner, FaChartLine, FaArrowUp, FaArrowDown, FaMoneyBillWave } from "react-icons/fa";

const DetailedIncomeStatement = ({ rdata, startDate, endDate }) => {
  const [incomeStatementData, setIncomeStatementData] = useState([]);
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [totalExpenses, setTotalExpenses] = useState(0);
  const [netIncome, setNetIncome] = useState(0);
  const [loading, setLoading] = useState(true)

  const {allData, setAllData} = useOutletContext();

  useEffect(() => {
    const fetchData = () => {
      
      let revenueTotal = 0;
      let expensesTotal = 0;
      

      const dataMap = {}; 

rdata.bills.forEach((res) => {
    const coa = allData.budget?.find((b) => b.id === res.coa_id)?.coa || "Unknown";

    const fromCoa = sumOfArray(
        rdata.journal
            .filter((a) => a.from_coa === res.coa_id)
            .map((entry) => parseFloat(entry.amount))
    );
    const toCoa = sumOfArray(
        rdata.journal
            .filter((a) => a.to_coa === res.coa_id)
            .map((entry) => parseFloat(entry.amount))
    );

    let amu = 0.0
    if(coa === '157004'){
      amu = parseFloat(res.amount) * 0.05
    }else{
      amu = parseFloat(res.amount)
    }

    const amount = parseFloat(amu) + fromCoa - toCoa;

    
    const name = allData.coa?.find(item => item.account === coa)?.name || "Unknown";

    if (!dataMap[coa]) {
        dataMap[coa] = { name, amount, type: "revenue" };
    } else {
        dataMap[coa].amount += amount;
    }

    revenueTotal += amount;
});

rdata.journal.forEach((journalEntry) => {
    // const boz = rdata.bills?.find(item => item.coa_id === journalEntry.to_coa);
    // const soz = rdata.supplier.filter((a) => a.type == 1)?.find(item => item.coa === journalEntry.to_coa);
    // if (boz || soz) return;

    const coaCode = allData.budget?.find(item => item.id === journalEntry.to_coa)?.coa;
    const amount = parseFloat(journalEntry.amount);
    const name = allData.coa?.find(item => item.account === coaCode)?.name || "Unknown";
    let type = coaCode?.[0] == "1" ? "revenue" : "expense";

    if([3,4,5,6].includes(parseInt(coaCode?.[0]))){

    }else{
      if (!dataMap[coaCode]) {
        dataMap[coaCode] = { name, amount, type };
    } else {
        dataMap[coaCode].amount += amount;
    }

    if (type === "revenue") {
        revenueTotal += amount;
    } else {
        expensesTotal += amount;
    }
    }

  
});

rdata.supplier
    .filter((a) => a.type == 1 && a.expense == 'None')
    .forEach((res) => {
        const fromCoa = sumOfArray(
            rdata.journal
                .filter((a) => a.from_coa === res.coa)
                .map((entry) => parseFloat(entry.amount))
        );
        const toCoa = sumOfArray(
            rdata.journal
                .filter((a) => a.to_coa === res.coa)
                .map((entry) => parseFloat(entry.amount))
        );

        const coa = allData.budget?.find((b) => b.id === res.coa)?.coa;
        if (coa !== undefined && (coa[0] == "2")) {
            const amount = parseFloat(res.amount) - fromCoa + toCoa;
            const name = allData.coa?.find(item => item.account === coa)?.name || "Unknown";

            if (!dataMap[coa]) {
                dataMap[coa] = { name, amount, type: "expense" };
            } else {
                dataMap[coa].amount += amount;
            }

            expensesTotal += amount;
        }
    });



// Convert dataMap object to array
const data = Object.values(dataMap);


      setIncomeStatementData(data);
      setTotalRevenue(revenueTotal);
      setTotalExpenses(expensesTotal);
      setNetIncome(revenueTotal - expensesTotal);
    };

        if(rdata.bills){
          fetchData();
          setLoading(false)
        }
  }, [rdata]);

  const formatAmount = (amount) => formatToZMW(amount.toFixed(2));

  return (
    <div className="w-full space-y-6">
      {
        loading?
        <>
          <div className='flex flex-col justify-center items-center h-64 w-full bg-white rounded-2xl border border-gray-100 shadow-sm'>
            <FaSpinner size={50} className="animate-spin text-blue-950 mb-4" />
            <p className="text-gray-600 text-lg">Loading income statement...</p>
          </div>
        </>
        :
        <>
         <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
           <div className=" px-6 py-4">
             <div className="flex items-center gap-3 mb-2">
               <div className="bg-blue-950 rounded-lg p-2">
                 <FaChartLine className="text-white text-xl" />
               </div>
               <div>
                 <h2 className='font-bold text-xl'>{allData.council[0]?.name.toUpperCase()}</h2>
                 <p className="text-gray-600 text-sm">Income Statement Report</p>
               </div>
             </div>
             <h3 className='text-gray-500 text-sm font-medium'>From {formatDate(startDate)} to {formatDate(endDate)}</h3>
           </div>
           
           <div className="p-6">
             <div className="overflow-x-auto">
               <table id="detailed-income-statement" className="w-full border-collapse">
                 <thead>
                   <tr className="bg-gradient-to-r from-blue-950 to-blue-800 text-white">
                     <th className="text-left py-3 px-4 font-semibold">Item</th>
                     <th className="text-right py-3 px-4 font-semibold">Amount</th>
                   </tr>
                 </thead>
                 <tbody>
                   {/* Render Revenue Section */}
                   <tr className="bg-gradient-to-r from-green-50 to-green-100 border-b-2 border-green-200">
                     <td className="py-3 px-4 font-bold text-green-800 flex items-center gap-2">
                       <FaArrowUp className="text-green-600" />
                       Revenue
                     </td>
                     <td className="py-3 px-4"></td>
                   </tr>
                   {incomeStatementData
                     .filter((item) => item.type === "revenue")
                     .map((item, index) => (
                       <tr key={`revenue-${index}`} className="hover:bg-gray-50 border-b border-gray-100">
                         <td className="py-2 px-4 pl-8 text-gray-700">{item.name}</td>
                         <td className="py-2 px-4 text-right font-medium text-green-700">{formatAmount(item.amount)}</td>
                       </tr>
                     ))}
                   <tr className="bg-gradient-to-r from-green-700 to-green-800 text-white font-bold">
                     <td className="py-3 px-4 flex items-center gap-2">
                       <FaMoneyBillWave />
                       Total Revenue
                     </td>
                     <td className="py-3 px-4 text-right">{formatAmount(totalRevenue)}</td>
                   </tr>

                   {/* Render Expense Section */}
                   <tr className="bg-gradient-to-r from-red-50 to-red-100 border-b-2 border-red-200">
                     <td className="py-3 px-4 font-bold text-red-800 flex items-center gap-2">
                       <FaArrowDown className="text-red-600" />
                       Expense
                     </td>
                     <td className="py-3 px-4"></td>
                   </tr>
                   {incomeStatementData
                     .filter((item) => item.type === "expense")
                     .map((item, index) => (
                       <tr key={`expense-${index}`} className="hover:bg-gray-50 border-b border-gray-100">
                         <td className="py-2 px-4 pl-8 text-gray-700">{item.name}</td>
                         <td className="py-2 px-4 text-right font-medium text-red-700">{formatAmount(item.amount)}</td>
                       </tr>
                     ))}
                   <tr className="bg-gradient-to-r from-red-600 to-red-700 text-white font-bold">
                     <td className="py-3 px-4 flex items-center gap-2">
                       <FaMoneyBillWave />
                       Total Expense
                     </td>
                     <td className="py-3 px-4 text-right">{formatAmount(totalExpenses)}</td>
                   </tr>
                 </tbody>
                 <tfoot>
                   <tr className="bg-gray-50 border-t-2 border-gray-300">
                     <th className="text-left py-3 px-4 font-bold text-gray-800">Total Revenue</th>
                     <th className="text-right py-3 px-4 font-bold text-green-700" id="total-revenue">{formatAmount(totalRevenue)}</th>
                   </tr>
                   <tr className="bg-gray-50">
                     <th className="text-left py-3 px-4 font-bold text-gray-800">Total Expenses</th>
                     <th className="text-right py-3 px-4 font-bold text-red-700" id="total-expenses">{formatAmount(totalExpenses)}</th>
                   </tr>
                   <tr className={`bg-gradient-to-r ${netIncome >= 0 ? 'from-blue-500 to-blue-600' : 'from-orange-500 to-orange-600'} text-white font-bold border-t-2 border-gray-400`}>
                     <th className="text-left py-3 px-4 flex items-center gap-2">
                       <FaChartLine />
                       Surplus (Deficit)
                     </th>
                     <th className="text-right py-3 px-4 text-lg" id="net-income">{formatAmount(netIncome)}</th>
                   </tr>
                 </tfoot>
               </table>
             </div>
           </div>
         </div>
        </>
      }
     
    </div>
  );
};

export default DetailedIncomeStatement;
